import { deactivateGalleryItems, wrapAll, watchAwaitSelector, isVisible, throttle, debounce } from './functions'

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  const navWrapper = document.querySelector('.ProductGallery__NavigationWrapper')
  const navScroll = document.querySelector('.ProductGallery__Navigation')
  const navItems = document.querySelectorAll('.ProductGallery__NavigationItem')
  const imageWrappers = document.querySelectorAll('.ProductGallery__ImageWrapper')
  const activeClass = 'is-active'

  let noActiveImages = true

  for (const item of navItems) {
    const id = item.dataset.imageId
    const image = document.getElementById(id)

    if (item.classList.contains('is-active')) {
      // A gallery image is properly displayed on page load
      noActiveImages = false
    }

    if (id && image) {
      item.addEventListener('click', function (event) {
        deactivateGalleryItems(navItems, imageWrappers, activeClass)
        item.classList.add(activeClass)
        image.classList.add(activeClass)
      })
    }
  }

  if (noActiveImages === true && navItems.length > 0 && imageWrappers.length > 0) {
    const id = navItems[0].dataset.imageId
    const image = document.getElementById(id)

    // Gallery image failed to be activated/loaded, fix it
    if (id && image) {
      navItems[0].classList.add(activeClass)
      image.classList.add(activeClass)
    }
  }

  if (navItems.length > 0) {
    const lastImage = navItems[navItems.length - 1]

    function removeBlur() {
      navWrapper.classList.add('remove-blur')
    }

    function addBlur() {
      navWrapper.classList.remove('remove-blur')
    }

    navScroll.addEventListener(
      'scroll',
      debounce(function (event) {
        isVisible(lastImage, 0.1, removeBlur, addBlur)
      }, 100)
    )
  }

  watchAwaitSelector(function () {
    const previous = document.querySelector('.flickity-prev-next-button.previous')
    const dots = document.querySelector('.flickity-page-dots')
    const next = document.querySelector('.flickity-prev-next-button.next')
    const flickityViewport = document.querySelector('.flickity-viewport')

    if (previous && dots && next && flickityViewport) {
      const wrapper = document.createElement('div')
      wrapper.classList.add('flickity-custom-nav-wrapper')

      flickityViewport.after(wrapper)
      wrapAll(wrapper, [previous, dots, next])
    }
  }, '.flickity-page-dots')
})
